import React, { useMemo } from 'react';
import { StyleSheet, Text } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { AppButton } from '../../components/AppButton';
import { AppScreen } from '../../components/AppScreen';
import { spacing } from '../../constants/spacing';
import { typography } from '../../constants/typography';
import { useAppColors } from '../../context/PreferencesContext';

export function UnauthorizedScreen() {
  const navigation = useNavigation();
  const palette = useAppColors();

  const themed = useMemo(
    () => ({
      title: {
        ...typography.screenTitle,
        color: palette.textPrimary,
        textAlign: 'center' as const,
      },
      message: {
        ...typography.body,
        color: palette.textSecondary,
        textAlign: 'center' as const,
      },
    }),
    [palette],
  );

  return (
    <AppScreen contentStyle={styles.screen}>
      <Text style={themed.title}>Access Unavailable</Text>
      <Text style={themed.message}>You do not have permission to view this screen.</Text>
      {navigation.canGoBack() ? (
        <AppButton title="Return" onPress={() => navigation.goBack()} />
      ) : null}
    </AppScreen>
  );
}

const styles = StyleSheet.create({
  screen: { justifyContent: 'center', gap: spacing.lg },
});
